var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uploadIco_svg__a{fill:none}.uploadIco_svg__b{fill:rgba(0,0,0,.87)}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-548 -52)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "uploadIco_svg__a",
    width: 28,
    height: 28,
    rx: 2,
    transform: "translate(548 52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uploadIco_svg__a",
    d: "M551.5 55.5h21v21h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uploadIco_svg__b",
    d: "M561.125 61.477l-2.266 2.261-1.234-1.238L562 58.125l4.375 4.375-1.234 1.238-2.266-2.261v8.461h-1.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uploadIco_svg__b",
    d: "M568.125 66v6.125h-12.25V66h-1.75v6.125a1.755 1.755 0 001.75 1.75h12.25a1.755 1.755 0 001.75-1.75V66z"
  }))));
}
export default SvgUploadIco;